exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.iframe[data-v-567ddaa4] {\n    min-height: 100rem;\n    height: -moz-max-content;\n    height: max-content;\n}\n", ""]);

// exports
